<template>
  <div class="page">
    <!-- header -->
    <MyHeader></MyHeader>
    <!-- header end -->

    <div class="content">
      <!-- slogan -->
      <div class="slogan" @click="playVideo($event, false)">
        <div class="slogan-title">
          <span v-html="$t('slogan')"></span>
        </div>
        <div class="slogan-tip">
          <span v-html="$t('sloganDetail')"></span>
        </div>
        <div class="slogan-tip mt-32">
          <span class="watch-border" @click="playVideo($event, true)">{{ $t('watchVideo') }}</span>
        </div>
      </div>
      <div>

      </div>
      <div class="bg-video" :class="{'display':hidden === false}">
        <iframe width="840" height="472" class="video-box"
                src="https://www.youtube.com/embed/I1EzAxB865o"
                title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen>
        </iframe>
      </div>

      <!-- storage -->
      <div class="storage">
        <div class="m-title">
          <div class="title fs-50">{{ $t('storage') }}</div>
          <div class="title-s fs-32">{{ $t('storageOne') }}</div>
          <div class="tip fs-16">{{ $t('storageTwo') }}</div>
        </div>

        <div class="list-read-item">
          <el-row>
            <el-col :lg="6" :sm="12" :xs="24">
              <div class="read-item">
                <div class="item-img img-enc"></div>
                <div class="item-title fs-28">{{ $t('storageI1Title') }}</div>
                <div class="item-tip fs-18">{{ $t('storageI1Content') }}</div>
              </div>
            </el-col>
            <el-col :lg="6" :sm="12" :xs="24">
              <div class="read-item">
                <div class="item-img img-share"></div>
                <div class="item-title fs-28">{{ $t('storageI2Title') }}</div>
                <div class="item-tip fs-18">{{ $t('storageI2Content') }}</div>
              </div>
            </el-col>
            <el-col :lg="6" :sm="12" :xs="24">
              <div class="read-item">
                <div class="item-img img-distrib"></div>
                <div class="item-title fs-28">{{ $t('storageI3Title') }}</div>
                <div class="item-tip fs-18">{{ $t('storageI3Content') }}</div>
              </div>
            </el-col>
            <el-col :lg="6" :sm="12" :xs="24">
              <div class="read-item">
                <div class="item-img img-multi"></div>
                <div class="item-title fs-28">{{ $t('storageI4Title') }}</div>
                <div class="item-tip fs-18">{{ $t('storageI4Content') }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="storage-explain explain-block flex-center">
        <p class="fs-40">{{ $t('storageTips') }}</p>
      </div>

      <!-- STORAGE V & A -->
      <div class="secure">
        <div class="m-title">
          <div class="title fs-40">{{ $t('storageVA') }}</div>
          <div class="title-s fs-32">{{ $t('storageVATip') }}</div>
        </div>

        <div class="m-details flex-center flex-wrap">
            <div class="m-intro">
              <div class="d-flex">
                <div class="eg bg-orange"></div>
                <div class="eg-title fs-28">
                  <span v-html="$t('storageVA1Title')"></span>
                </div>
              </div>
              <div class="content fs-28" v-html="$t('storageVA1Msg')"></div>
              <div class="img-service"></div>
            </div>
            <div class="m-intro">
              <div class="d-flex">
                <div class="eg bg-green"></div>
                <div class="eg-title fs-28">
                  <span v-html="$t('storageVA2Title')"></span>
                </div>
              </div>
              <div class="content fs-28">{{ $t('storageVA2Msg') }}</div>
              <div class="img-filecoin"></div>
            </div>
        </div>
      </div>
      <div class="secure-explain explain-block flex-column flex-just-center">
        <span class="fs-40">{{ $t('storageVATips') }}</span>
        <span class="fs-40 mt-32" v-html="$t('storageVATips1')"></span>
      </div>

      <!-- storage-ss -->
      <div class="token flex-column">
        <div class="fs-50 fw-bold color-normal">{{ $t('tokenomics') }}</div>
        <div class="mt-8 fs-20 line-heigth-38">
          <span v-html="$t('storageSSMsg')"></span>
        </div>

        <div class="w-100 flex-around cost mt-120">
          <div class="text-right">
            <div class="fw-bold fs-40 line-heigth-38">{{ $t('storageCostTitle') }}</div>
            <div class="fs-24 line-heigth-38 mt-20">
              <span v-html="$t('storageCostTitleMsg')"></span>
            </div>
          </div>
          <div class="img img-storage-costs"></div>
        </div>

        <div class="w-100 flex-around reward mt-120">
          <div class="img img-reward"></div>
          <div class="text-left">
            <div class="fw-bold fs-40 line-heigth-38">
              <span v-html="$t('storageRewardTitle')"></span>
            </div>
            <div class="fs-24 line-heigth-38 mt-20">
              <span v-html="$t('storageRewardTitleMsg')"></span>
            </div>
          </div>
        </div>

        <div class="w-100 flex-around rewards mt-120">
          <div class="text-right">
            <div class="fw-bold fs-40 line-heigth-38">{{ $t('sharderPoolTitle') }}</div>
            <div class="fs-24 line-heigth-38 mt-20">
              <span v-html="$t('sharderPoolTip')"></span>
            </div>
          </div>
          <div class="rewards-txt">
            <div class="img img-rewards"></div>
            <div class="mt-40 fs-20 line-heigth-38">{{ $t('sharderPoolTip2') }}</div>
            <div class="mt-20 fs-20 line-heigth-38">{{ $t('sharderPoolTip4') }}</div>
          </div>
        </div>

        <!--<div class="w-100 flex-column mt-120">-->
          <!--<div class="fs-40 fw-bold line-heigth-38">{{ $t('sharderPoolTitle') }}</div>-->
          <!--<div class="mt-20 fs-24 line-heigth-38">{{ $t('sharderPoolTip') }}</div>-->
          <!--<div class="mt-40 fs-24 line-heigth-38">{{ $t('sharderPoolTip1') }}</div>-->
          <!--<div class="mt-40 img-rewards"></div>-->
          <!--<div class="mt-40 fs-20 line-heigth-38">{{ $t('sharderPoolTip2') }}</div>-->
          <!--<div class="mt-20 fs-20 line-heigth-38">{{ $t('sharderPoolTip3') }}</div>-->
          <!--<div class="mt-20 fs-20 line-heigth-38">{{ $t('sharderPoolTip4') }}</div>-->
        <!--</div>-->
      </div>

      <!-- partners -->
      <div class="partners flex-column">
        <div class="tabs flex-inline">
          <div class="tab fs-30" :class="{'active': partnerTabIndex===2}"  @click="partnerTabIndex=2">{{ $t('exchanges') }}</div>
          <div class="tab fs-30" :class="{'active': partnerTabIndex===0}" @click="partnerTabIndex=0">{{ $t('partners') }}</div>
          <div class="tab fs-30" :class="{'active': partnerTabIndex===1}"  @click="partnerTabIndex=1">{{ $t('wallets') }}</div>
        </div>
        <div class="panels">
          <transition-group name="fade" class="transit" tag="div">
            <div class="panel panel-part flex-inline flex-wrap mt-76" v-show="partnerTabIndex===0" key="1">
              <img class="img-part" v-for="(part, index) in partners" :key="index" :src="part">
            </div>
            <div class="panel panel-wallet flex-inline flex-wrap mt-100" v-show="partnerTabIndex===1" key="2">
              <img class="img-wallet" v-for="(wallet, index) in wallets" :key="index" :src="wallet">
            </div>
            <div class="panel panel-exchange d-flex flex-just-center flex-wrap" v-show="partnerTabIndex===2" key="3">
              <div class="uniswap-box flex-column">
                <div class="uniswap mb-20 pointer" @click="uniswapLink"></div>
                <iframe
                  src="https://uniswap.exchange/swap?theme=light&inputCurrency=ETH&outputCurrency=0xbbff862d906e348e9946bfb2132ecb157da3d4b4"
                  height="660px"
                  width="100%"
                  style="
                        border: 0;
                        margin: 0 auto;
                        display: block;
                        border-radius: 10px;
                        max-width: 600px;
                        min-width: 300px;
                        border: 1px solid #f5f5f5;
                      "
                  id="myId"
                />
              </div>
              <div class="icon-box">
                <img class="img-exchange" :class="{ 'pointer': [0,1,2].includes(index) }" v-for="(exchange, index) in exchanges" :key="index" :src="exchange" @click="exchangeLink(index)">
              </div>
            </div>
          </transition-group>
        </div>
      </div>
    </div>

    <!-- footer -->
    <MyFooter></MyFooter>
  </div>
</template>
<script>
  import MyHeader from '@/views/components/Header.vue'
  import MyFooter from '@/views/components/Footer.vue'

  export default {
    name: 'Main',
    components: { MyHeader, MyFooter },
    data () {
      return {
        hidden: false,
        partnerTabIndex: 2,
        partners: [require('../../static/link1/netcourt.png'), require('../../static/link1/seachange.png'), require('../../static/link1/galaxy.png'),
          require('../../static/link1/zbj.png'), require('../../static/link1/bornsoft.png'), require('../../static/link1/kaxi.png'),
            require('../../static/link1/yingke.png'), require('../../static/link1/sxqian.png'), require('../../static/link1/cqqj.png'), require('../../static/link1/yjf.png')],
        wallets: [require('../../static/link2/ledger.png'), require('../../static/link2/metamask.png'), require('../../static/link2/mew.png'),
          require('../../static/link2/mycrypto.png'), require('../../static/link2/trezor.png'), require('../../static/link2/trust.png')],
        exchanges: [require('../../static/link3/hotbit.png'), require('../../static/link3/idex.png'),
          require('../../static/link3/bilaxy.png'), require('../../static/link3/bit-z.png')]
      }
    },
    methods: {
      playVideo(e, flag) {
        this.hidden = flag;
        e.stopPropagation();
      },
      exchangeLink (index) {
        if (index === 0) {
          window.open('https://www.hotbit.io/exchange?symbol=SS_ETH')
        } else if (index === 1) {
          window.open('https://idex.market/eth/ss')
        } else if (index === 2) {
          window.open('https://www.bilaxy.com/exchange#symbol=25')
        }
      },
      uniswapLink () {
        window.open('https://uniswap.exchange/swap?inputCurrency=0xbbff862d906e348e9946bfb2132ecb157da3d4b4')
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '../styles/common.scss';

  /* home */
  .slogan {
    width: 100%;
    height: 81rem;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;
    background: #010812 url("../../static/world-map-lines.svg") left center no-repeat;
    background-size: cover;
    color: #FFFFFF;
    text-align: left;

    .slogan-title {
      /*margin-left: 30.6%;*/
      text-align: center;
      font-size: 8rem;
      font-weight: bold;
    }
    .slogan-tip {
      /*margin-left: 30.6%;*/
      text-align: center;
      font-size: 3.2rem;
    }
    .watch-border {
      font-size: 2.5rem;
      padding: 5px 15px;
      border: 2px solid white;
      border-radius: 0.4rem;
      cursor: pointer;
    }

    .watch-border:hover {
      font-size: 2.5rem;
      padding: 5px 15px;
      border: 2px solid red;
      border-radius: 0.4rem;
      color: hsla(0, 0%, 92.9%, .9);
      border-image: linear-gradient(135deg, #f6f8fc, #bebebe) 4 4;
      clip-path: inset(0 round 4px);
      cursor: pointer;
    }
  }

  .mt-32 {
    margin-top: 32px;
  }

  .bg-video {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -420px;
    margin-top: -280px;
  }

  .display {
    display: none;
  }

  .storage {
    display: flex;
    flex-direction: column;
    align-items: center;

    .m-title {
      margin-top: 10rem;
      .title {
        font-weight: bold;
        color: #010812;
      }
      .title-s {
        margin-top: 1.5rem;
        font-size: 3.2rem;
        color: #000000;
      }
      .tip {
        margin-top: 0.5rem;
        color: #707070;
      }
    }

    .list-read-item {
      width: 100%;
      margin-top: 12rem;
      margin-bottom: 10rem;

      .el-row {
        width: 100%;

        .el-col {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .read-item {
        max-width: 34rem;
        .item-img {
          width: 16rem;
          height: 16rem;
        }
        .item-title {
          margin-top: 2.3rem;
          font-weight: bold;
          text-align: left;
          color: #222222;
        }
        .item-tip {
          margin-top: 1.7rem;
          text-align: left;
          color: #707070;
        }

        .img-enc {
          background: url("../../static/encryption.png") center no-repeat;
        }
        .img-share {
          background: url("../../static/data-sharding.png") center no-repeat;
        }
        .img-distrib {
          background: url("../../static/distributed.png") center no-repeat;
        }
        .img-multi {
          background: url("../../static/multiple.png") center no-repeat;
        }
      }
    }
  }

  .explain-block {
    width: 100%;
    height: 40.8rem;
    color: #FFFFFF;
    line-height: 6rem;

    p {
      max-width: 103.2rem;
      text-align: left;
    }
  }

  .storage-explain {
    background: url("../../static/sharder-protocol-bg.png") center no-repeat;
    background-size: cover;
  }

  .secure {
    padding: 10rem 0;

    .m-title {
      .title {
        font-weight: bold;
        color: #010812;
      }
      .title-s {
        margin-top: 0.8rem;
      }
    }

    .m-details {
      margin-top: 12rem;

      .m-intro {
        width: 75.2rem;
        padding: 4.8rem;
        .eg {
          width: 0.8rem;
          height: 7.2rem;
          margin-right: 2rem;
        }
        .eg-title {
          font-weight: bold;
          line-height:3.8rem;
          text-align: left;
        }

        .content {
          min-height: 25rem;
          margin-top: 4rem;
          padding-left: 2.8rem;
          line-height: 6rem;
          text-align: left;
        }

        .img-service {
          width: 70.4rem;
          height: 37.4rem;
          margin-top: 1.6rem;
          background: url("../../static/NOTARY SERVICES.png") center no-repeat;
          background-size: contain;
        }
        .img-filecoin {
          width: 70.4rem;
          height: 37.4rem;
          margin-top: 1.6rem;
          background: url("../../static/FILECOIN USER.png") left center no-repeat;
          background-size: contain;
        }

        &:first-child {
          margin-right: 2.08%;
        }
      }
    }
  }
  .secure-explain {
    background: url("../../static/ss-token-bg.png") center no-repeat;
    background-size: cover;
  }

  .token {
    padding: 10rem 15rem;
  }

  .img-storage-costs {
    width: 49rem;
    height: 47.6rem;
    background: url("../../static/storage-costs.png") left center no-repeat;
    background-size: contain;
  }

  .img-reward {
    width: 49rem;
    height: 50.3rem;
    background: url("../../static/ss-reward.png") center no-repeat;
  }

  .img-rewards {
    width: 60.3rem;
    height: 20.6rem;
    background: url("../../static/cpos-pools.png") center no-repeat;
    background-size: 60.3rem;
  }

  .partners {
    margin-bottom: 10rem;
    .tabs {
      width: 68rem;

      .tab {
        color: #B3B3B3;
        font-weight: bold;
        line-height: 8rem;
        position: relative;
        cursor: pointer;
        transition: all .3s ease;

        &::after {
          content: "";
          width: 0;
          height: 0.6rem;
          position: absolute;
          bottom: 0;
          left: 50%;
          opacity: 0;
          transform: translateX(-50%);
          background-color: #003399;
          transition: width .3s ease;
        }

        &:hover,
        &.active {
          color: #000000;
        }
        &:hover::after,
        &.active::after {
          width: 8rem;
          opacity: 1;
        }

      }
    }

    .panels {
      width: 100%;
      .transit {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
      }

      .panel-part {
        width: 128rem;
      }
      .panel-wallet {
        width: 68rem;

        .img-wallet {
          margin-bottom: 3.2rem;
        }
      }
      .panel-exchange {
        width: 80%;
        display: flex;
        align-items: flex-start;

        .uniswap {
          width: 18rem;
          height: 7rem;
          background: url('../../static/link3/uniswap.png') center no-repeat;
          background-size: 18rem;
        }

        .icon-box {
          width: 50rem;
          margin-top: 10rem;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;

          .img-exchange {
            margin-bottom: 3.2rem;
          }
        }
      }

      .img-part {
        max-width: 18rem;
        max-height: 7rem;
        margin-bottom: 6.5rem;
        &:not(:nth-child(5n)) {
          margin-right: 9rem;
        }
      }

      .img-wallet,
      .img-exchange {
        max-width: 18rem;
        max-height: 7rem;
      }
    }

    .uniswap-box {
      width: 600px;
      margin-top: 3rem;
      margin-right: 10rem;
    }
  }
  /* home end */

  /* 其他样式 */
  .d-flex {
    display: flex;
    align-items: center;
  }
  .bg-orange {
    background-color: #F6AB11;
  }
  .bg-green {
    background-color: #00D2D6;
  }

  .color-deepblue {
    color: #00157B;
  }
  .color-039 {
    color: #003399;
  }

  .mt-76 {
    margin-top: 7.6rem;
  }
  .mt-32 {
    margin-top: 3.2rem;
  }
  .pointer {
    cursor: pointer;
  }

  .mb-20 {
    margin-bottom: 2rem;
  }

  .rewards-txt {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  /* 动画 */
  .fade-enter-active {
    opacity: 0;
    height: 0;
    transition: all 1s;
  }
  .fade-enter-to {
    opacity: 1;
    height: auto;
  }
</style>

<style lang="scss" scoped>
  /* media query */
  @media screen and (max-width: 1800px) {
    .secure .m-details {
      display: flex;
      justify-content: space-around;

      .m-intro {
        width: 64rem;
        padding: 1rem;

        .img-filecoin,
        .img-service {
          width: 60rem;
        }
      }
      .m-intro:first-child {
        margin-right: 0;
        margin-top: 0;
      }
    }

    .video-box {
      width: 840px;
      height: 472px;
    }

  }

  @media screen and (max-width: 1660px) {
    .list-read-item .read-item {
      margin-top: 4rem;
    }

    .token {
      padding: 10rem 0;

      .cost,
      .reward {
        display: flex;
        align-items: center;
        justify-content: space-around;

        .img {
          margin-top: 4rem;
        }
      }
    }

    .slogan .slogan-title {
      font-size: 6rem;
    }

    .partners .uniswap-box {
      margin-right: 5rem;
    }
    .partners .panels .panel-exchange .icon-box {
      width: 40rem;
    }
  }

  @media screen and (max-width: 1400px) {
    .partners .panels .panel-exchange {
      width: 90%;
    }
    .partners .uniswap-box {
      margin-right: 3rem;
    }
  }

  @media screen and (max-width: 1350px) {
    .secure .m-details {
      display: flex;
      flex-direction: column;
      justify-content: center;

      .m-intro:first-child {
        margin-bottom: 3rem;
      }
    }

  }

  @media screen and (max-width: 1300px) {
    .partners .panels .panel-part {
      width: 90%;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;

      .img-part {
        margin-right: 0;
      }
    }

    .partners .uniswap-box {
      margin-right: 0;
    }

    .partners .panels .panel-exchange {
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .icon-box {
        margin-top: 3rem;
      }
    }
  }

  @media screen and (max-width: 1200px) {
    .partners .panels {
      .panel-wallet {
        width: 80%;
      }
      .panel-exchange {
        width: 80%;
      }
    }

    .video-box {
      width: 560px;
      height: 315px;
    }

    .bg-video {
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -280px;
      margin-top: -180px;
    }
  }

  @media screen and (max-width: 1000px) {
    .token {
      padding: 10rem 1rem;

      .cost,
      .reward,
      .rewards {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        div {
          text-align: center;
        }

        .img {
          margin-top: 4rem;
        }
      }

      .reward {
        flex-direction: column-reverse;
      }
    }
  }

  @media screen and (max-width: 900px) {
    .slogan {
      height: 65rem;
      padding-bottom: 0;
      justify-content: center;
      background-position: center;
      background-size: cover;

      .slogan-title {
        margin-left: 0;
        text-align: center;
        font-size: 2.8rem;
      }
      .slogan-tip {
        margin-left: 0;
        text-align: center;
        font-size: 1.4rem;
      }
    }

    .video-box {
      width: 560px;
      height: 315px;
    }

    .secure .m-details .m-intro {
      width: 90%;
      padding: 1rem;

      .content {
        line-height: 3rem;
        min-height: initial;
      }

      .img-service,
      .img-filecoin {
        width: 100%;
        height: 30rem;
        background-size: contain;
        background-position: center;
      }
    }

    .partners {
      .tabs {
        width: 95%;
      }
      .transit {
        .flex-inline {
          justify-content: center;
        }
      }

      .uniswap-box {
        width: 100%;
      }
    }

    .partners .panels .panel-exchange {
      width: 90%;

      #myId {
        width: 100%;
      }

      .icon-box {
        width: 100%;
        flex-direction: column;
        align-items: center;
      }
    }

    .storage {
      padding: 0 1rem;
    }

    .token {
      padding: 5rem 1rem;

      .img-reward,
      .img-rewards,
      .img-storage-costs {
        width: 90%;
        background-size: contain;
        background-position: center;
      }

      .mt-120 {
        margin-top: 5rem;
      }

      .line-heigth-38 {
        line-height: 1.4;
      }
    }

    @each $fs in 16, 18, 20, 24, 28, 30, 32, 40, 50 {
      .fs-#{$fs} {
        font-size: #{$fs/14}rem;
      }
    }

    .secure-explain,
    .storage-explain {
      padding: 3rem 0;
    }
    .secure-explain,
    .storage-explain {
      height: auto;
      .fs-40 {
        padding: 1rem 1rem;
        font-size: 2rem;
        line-height: 3rem;
        margin-top: 0;
        margin-bottom: 0;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .storage {
      .list-read-item {
        justify-content: center;
        margin-top: 5rem;

        .read-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          .item-tip {
            text-align: center;
          }
        }
      }

      .m-title {
        margin-top: 5rem;
      }
    }

    .video-box {
      width: 280px;
      height: 157px;
    }

    .bg-video {
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -140px;
      margin-top: -120px;
    }

    .secure {
      padding-top: 8rem;

      .m-details {
        margin-top: 6rem;
      }
    }

    .partners .panels {
      .panel-exchange {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .img-exchange {
          margin-bottom: 0;
        }
      }

      .panel-part .img-part {
        margin-bottom: 0;
      }

      .panel-wallet .img-wallet {
        margin-bottom: 0;
      }
    }

  }

</style>
